// packages/ui/src/components/ApprovalCard.tsx
import { BeszelDiskCard } from './BeszelDiskCard.js'
import { HealthCheckDiskCard } from './HealthCheckDiskCard.js'

export function ApprovalCard({ approval }: { approval: { kind: string; [key: string]: unknown } }) {
  if (approval.kind === 'beszel_disk') {
    return <BeszelDiskCard approval={approval as any} />
  }

  if (approval.kind === 'health_check_disk') {
    return <HealthCheckDiskCard approval={approval as any} />
  }

  // Fallback for renovate_pr and unknown kinds
  return (
    <div className="border rounded-lg p-4">
      <div className="font-semibold text-sm">{String(approval.title ?? approval.kind)}</div>
      <div className="text-xs text-gray-500">{String(approval.status)}</div>
    </div>
  )
}
